// Foundations
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

// rxjs
import { finalize } from 'rxjs/operators';

// Components
import { ConfirmDialogComponent } from '../_share/confirm-dialog/confirm-dialog.component';
import { PasswordFormComponent } from '../_share/password-form/password-form.component';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CognitoService } from '../../services/cognito.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('appPasswordForm', { static: false }) appPasswordForm: PasswordFormComponent;

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _analytics: AnalyticsService,
    private cognitoService: CognitoService,
    private loadingIndicatorService: LoadingIndicatorService,
  ) {
    this.form = this.fb.group({
      password: ['', { validators: [Validators.required] }],
      passwordForm: []
    });
  }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  get f(): any {
    return this.form.controls;
  }

  onSavePassword() {
    this._analytics.logButtonTap('changePassword_save');
    const password = this.form.get('password').value;
    const newPassword = this.form.get('passwordForm').value.confirmPassword;

    if (this.form.valid) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'general-dialog',
        data: {
          title: 'Change Password',
          content: 'Are you sure you want to change password?',
          cancelText: 'No',
          okText: 'Yes',
          okFn: () => {
            dialogRef.close();
            this.loadingIndicatorService.show();
            this.cognitoService.changePassword(password, newPassword)
              .pipe(finalize(() => this.loadingIndicatorService.hide()))
              .subscribe(status => {
                if (status.result === 'SUCCESS') {
                  this.snackBar.open('Password successfully updated.', '', { duration: 2000 });
                  this.router.navigate(['/']);
                }
                else {
                  if (status.result === 'NotAuthorizedException') {
                    this.snackBar.open('Current password is incorrect.', '', { duration: 2000 });
                  } else {
                    this.snackBar.open(status.message, '', { duration: 2000 });
                  }
                  this.form.reset();
                  this.appPasswordForm.form.reset();
                }
              });
            this.form.markAsPristine();
          }
        },
        autoFocus: false
      });


    }
  }
}
